const ITEMS = [
  "3D PRINTING • PROTOTYPING",
  "WEBSITE DESIGN • ECOMMERCE",
  "PHYSICAL BRAND ASSETS",
  "DIGITAL BRAND IDENTITY",
  "PRODUCT LAUNCH",
  "TURNKEY MEDIA • MARKETING",
];

const Track = () => (
  <div className="flex items-center gap-10 px-6 font-display uppercase tracking-widest text-lg text-neutral-400 whitespace-nowrap">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center gap-10">
        <span>{item}</span>
        <span className="text-[#45f3ff]">◆</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="services-marquee"
      className="border-y border-[#24283b] bg-[#0e111a] py-4 overflow-hidden"
    >
      <div className="mq-track">
        <Track />
        <Track />
      </div>
    </div>
  );
}
